import { en } from './en/en.js'
import { es } from './es/es.js'

export const localeValue = {
  es: es,
  en: en
}
